import { parseCoachIdentityTemplate, type CoachIdentityTemplateParseResult } from "@/lib/behavior/coachIdentityTemplate";

export const COACH_IDENTITY_HANDOFF_KEY = "coach-identity-builder-template";

function extractTemplateSource(raw: string): string {
  const fenceMatch = raw.match(/```(?:md|markdown)?\s*([\s\S]*?)```/i);
  const candidate = fenceMatch?.[1] || raw;
  const start = candidate.indexOf("# Coach Identity Template");
  return start >= 0 ? candidate.slice(start).trim() : candidate.trim();
}

export function parseCoachIdentityBuilderDraft(raw: string): CoachIdentityTemplateParseResult {
  return parseCoachIdentityTemplate(extractTemplateSource(raw));
}

export function saveCoachIdentityBuilderDraft(raw: string) {
  sessionStorage.setItem(COACH_IDENTITY_HANDOFF_KEY, raw);
}

export function consumeCoachIdentityBuilderDraft(): string | null {
  const raw = sessionStorage.getItem(COACH_IDENTITY_HANDOFF_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(COACH_IDENTITY_HANDOFF_KEY);
  return raw;
}
